export default __webpack_public_path__ + "static/media/08.b2b3960f.jpg";